module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_arrow_right02-0ad5bdc01be48bfd6e9a3ef19273beeb.svg";